(() => {
  // app/scripts/embla-component.js
  if (!customElements.get("embla-component")) {
    customElements.define(
      "embla-component",
      class EmblaComponent extends HTMLElement {
        constructor() {
          super();
          this.delay = Number(this.dataset.autoplayTimeout || 0) * 1e3;
          this.loop = this.dataset.loop === "true";
          this.embla = null;
          this.autoplay = null;
          this.isPaused = false;
          this.init = this.init.bind(this);
          this.togglePlay = this.togglePlay.bind(this);
          this.resetAutoplay = this.resetAutoplay.bind(this);
        }
        connectedCallback() {
          if (window.EmblaCarousel && window.EmblaCarouselAutoplay) {
            this.init();
          } else {
            this.waitForEmbla();
          }
        }
        waitForEmbla() {
          this.loader = setInterval(() => {
            if (window.EmblaCarousel && window.EmblaCarouselAutoplay) {
              clearInterval(this.loader);
              this.init();
            }
          }, 200);
        }
        init() {
          if (this.embla)
            return;
          const root = this.querySelector(".embla");
          if (!root)
            return;
          this.viewport = root.querySelector(".embla__viewport");
          this.prevBtn = root.querySelector(".embla__button--prev");
          this.nextBtn = root.querySelector(".embla__button--next");
          this.dotsWrap = this.querySelector(".embla__dots");
          this.playToggle = this.querySelector(".embla__play-toggle");
          this.thumbs = [...this.querySelectorAll(".embla-thumb")];
          this.scrollbar = this.querySelector(".embla__scrollbar");
          this.scrollbarThumb = this.querySelector(".embla__scrollbar__thumb");
          this.autoplay = this.delay > 0 ? window.EmblaCarouselAutoplay({
            delay: this.delay,
            stopOnInteraction: false,
            stopOnMouseEnter: true
          }) : null;
          this.embla = EmblaCarousel(
            this.viewport,
            {
              loop: this.loop,
              align: "start",
              containScroll: "trimSnaps",
              draggable: true
            },
            this.autoplay ? [this.autoplay] : []
          );
          this.setupDots();
          this.setupThumbs();
          this.setupButtons();
          this.setupScrollbar();
          this.playToggle?.addEventListener("click", this.togglePlay);
          this.embla.on("select", () => {
            this.updateDots();
            this.updateThumbs();
          });
        }
        /* --------------------------
         * DOTS
         * -------------------------- */
        setupDots() {
          if (!this.dotsWrap)
            return;
          this.dotsWrap.innerHTML = "";
          this.dots = this.embla.slideNodes().map((_, index) => {
            const btn = document.createElement("button");
            btn.className = "embla__dot";
            btn.addEventListener("click", () => {
              this.embla.scrollTo(index);
              this.resetAutoplay();
            });
            this.dotsWrap.appendChild(btn);
            return btn;
          });
          this.updateDots();
        }
        updateDots() {
          if (!this.dots)
            return;
          const index = this.embla.selectedScrollSnap();
          this.dots.forEach(
            (dot, i) => dot.classList.toggle("is-selected", i === index)
          );
        }
        /* --------------------------
         * BUTTONS
         * -------------------------- */
        setupButtons() {
          this.prevBtn?.addEventListener("click", () => {
            this.embla.scrollPrev();
            this.resetAutoplay();
          });
          this.nextBtn?.addEventListener("click", () => {
            this.embla.scrollNext();
            this.resetAutoplay();
          });
        }
        /* --------------------------
         * AUTOPLAY CONTROLS
         * -------------------------- */
        resetAutoplay() {
          if (!this.autoplay || this.isPaused)
            return;
          this.autoplay.reset();
        }
        togglePlay() {
          if (!this.autoplay)
            return;
          this.isPaused = !this.isPaused;
          if (this.isPaused) {
            this.autoplay.stop();
            this.playToggle?.classList.add("is-paused");
          } else {
            this.autoplay.play();
            this.playToggle?.classList.remove("is-paused");
          }
        }
        /* --------------------------
         * THUMBNAILS
         * -------------------------- */
        setupThumbs() {
          if (!this.thumbs.length)
            return;
          this.thumbs.forEach((thumb, index) => {
            thumb.addEventListener("click", () => {
              this.embla.scrollTo(index);
              this.resetAutoplay();
            });
          });
          this.updateThumbs();
        }
        updateThumbs() {
          if (!this.thumbs.length)
            return;
          const index = this.embla.selectedScrollSnap();
          this.thumbs.forEach(
            (thumb, i) => thumb.classList.toggle("is-selected", i === index)
          );
        }
        // Scrollbar
        setupScrollbar() {
          if (!this.scrollbar || !this.scrollbarThumb)
            return;
          if (!this.embla.canScrollNext()) {
            this.scrollbar.classList.add("hidden");
          }
          const updateThumb = () => {
            const progress = this.embla.scrollProgress();
            const maxTranslate = this.scrollbar.offsetWidth - this.scrollbarThumb.offsetWidth;
            this.scrollbarThumb.style.transform = `translateX(${progress * maxTranslate}px)`;
          };
          const resizeThumb = () => {
            const slidesInView = this.embla.slidesInView(true).length;
            const totalSlides = this.embla.slideNodes().length;
            const widthPercent = Math.max(slidesInView / totalSlides, 0.7);
            this.scrollbarThumb.style.width = `${widthPercent * 100}%`;
          };
          this.embla.on("scroll", updateThumb).on("resize", resizeThumb).on("reInit", () => {
            resizeThumb();
            updateThumb();
          });
          resizeThumb();
          updateThumb();
        }
        /* --------------------------
         * CLEANUP
         * -------------------------- */
        disconnectedCallback() {
          clearInterval(this.loader);
          this.playToggle?.removeEventListener("click", this.togglePlay);
          this.autoplay?.stop();
          this.embla?.destroy();
          this.embla = null;
        }
      }
    );
  }
})();
